<template>
  <div>
    <el-card class="box-card">
      <div slot="header" class="clearfix flex justify-between">
        <span>{{ $t('storeIntegral.queryCondition') }}</span>
      </div>
      <div class="text item">
        <el-form :inline="true" :model="storeIntegralInfo.conditions" class="flex justify-start">
          <el-form-item>
            <el-input v-model="storeIntegralInfo.conditions.integralName"
              :placeholder="$t('storeIntegral.placeholder.integralName')" clearable />
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="_queryIntegralMethod">
              {{ $t('common.query') }}
            </el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-card>

    <el-card class="margin-top-sm">
      <div slot="header" class="clearfix flex justify-between">
        <span>{{ $t('storeIntegral.title') }}</span>
      </div>
      <div class="text item">
        <el-table :data="storeIntegralInfo.integrals" border style="width: 100%">
          <el-table-column prop="integralId" :label="$t('storeIntegral.table.id')" align="center" width="100" />
          <el-table-column prop="integralName" :label="$t('storeIntegral.table.accountName')" align="center" />
          <el-table-column prop="objType" :label="$t('storeIntegral.table.objectType')" align="center">
            <template slot-scope="scope">
              {{ scope.row.objType === '7007' ? $t('storeIntegral.merchant') : $t('storeIntegral.user') }}
            </template>
          </el-table-column>
          <el-table-column prop="objId" :label="$t('storeIntegral.table.objectId')" align="center" />
          <el-table-column prop="link" :label="$t('storeIntegral.table.phone')" align="center" />
          <el-table-column prop="amount" :label="$t('storeIntegral.table.points')" align="center" />
          <el-table-column :label="$t('common.operation')" align="center" width="250">
            <template slot-scope="scope">
              <el-button size="mini" @click="_changeIntegralAmount(scope.row, '1001')">
                {{ $t('storeIntegral.give') }}
              </el-button>
              <el-button size="mini" v-if="scope.row.amount > 0" @click="_changeIntegralAmount(scope.row, '2002')">
                {{ $t('storeIntegral.deduct') }}
              </el-button>
              <el-button size="mini" type="danger" @click="_openDeleteIntegralModel(scope.row)">
                {{ $t('common.delete') }}
              </el-button>
            </template>
          </el-table-column>
        </el-table>

        <el-pagination @current-change="handleCurrentChange" :current-page="currentPage" :page-size="pageSize"
          :total="total" layout="total, prev, pager, next" style="margin-top: 20px;" />
      </div>
    </el-card>

    <edit-integral ref="editIntegral" @refresh="queryIntegral" />
    <delete-integral ref="deleteIntegral" @refresh="queryIntegral" />
  </div>
</template>

<script>
import { listIntegral } from '@/api/admin/integralApi'
import EditIntegral from '@/components/admin/editIntegral/editIntegral.vue'
import DeleteIntegral from '@/components/admin/deleteIntegral/deleteIntegral.vue'

export default {
  name: 'StoreIntegral',
  components: {
    EditIntegral,
    DeleteIntegral
  },
  data() {
    return {
      storeIntegralInfo: {
        integrals: [],
        total: 0,
        records: 1,
        conditions: {
          integralName: '',
          objType: '7007',
          objId: '',
          amount: ''
        }
      },
      currentPage: 1,
      pageSize: 10
    }
  },
  created() {
    this._listIntegrals(this.currentPage, this.pageSize)
  },
  methods: {
    queryIntegral() {
      this._listIntegrals(1, 10)
    },
    async _listIntegrals(page, rows) {
      try {
        const params = {
          ...this.storeIntegralInfo.conditions,
          page,
          row: rows
        }
        const res = await listIntegral(params)
        this.storeIntegralInfo.integrals = res.data
        this.storeIntegralInfo.total = res.total
        this.storeIntegralInfo.records = res.records
      } catch (error) {
        console.error(error)
      }
    },
    _queryIntegralMethod() {
      this.currentPage = 1
      this._listIntegrals(this.currentPage, this.pageSize)
    },
    _changeIntegralAmount(integral, detailType) {
      this.$refs.editIntegral.open({
        detailType,
        integralName: integral.integralName,
        integralId: integral.integralId,
        amount: integral.amount,
        link: integral.link
      })
    },
    _openDeleteIntegralModel(integral) {
      this.$refs.deleteIntegral.open(integral)
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this._listIntegrals(this.currentPage, this.pageSize)
    }
  }
}
</script>

<style scoped>
.box-card {
  margin-bottom: 20px;
}
</style>